import React from "react";
import Cookies from "universal-cookie";
import PageTitle from "../../components/PageTitle/PageTitle";
import getCorsi from "../../services/getCorsi";
import getAule from "../../services/getAule";
import getStudenti from "../../services/getStudenti";
import getInsegnanti from "../../services/getInsegnanti";
import SearchTable from "../../widgets/tables/SearchTable";
import SelectPdfDatesWidget from "../../widgets/SelectPdfDatesWidget";
import SendMailWidget from "../../widgets/SendMailWidget";
import getSetting from "../../services/getSetting";
import saveFile from "../../services/saveFile";
import Utils from "../../utils/utils";
import sendMail from "../../services/sendMail";
import SendNotificationWidget from "../../widgets/SendNotificationWidget";
import addNotification from "../../services/addNotification";

export default class Search extends React.Component {
  constructor(props) {
    super(props);

    this.searchArray = [];
    this.sendMailRef = React.createRef();
    this.sendNotificationRef = React.createRef();

    this.state = {
      isLoading: true,
      array: [],
      previous: undefined,
      selectPdfDatesVisible: false,
      sendMailVisible: false,
      sendNotificationVisible: false,
      selectDateAulaVisible: false,
    };
  }

  async componentDidMount() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });

    this.corsi = await getCorsi(username, token);
    this.aule = await getAule(username, token);
    this.insegnanti = await getInsegnanti(username, token);
    this.studenti = await getStudenti(username, token);

    window.sessionStorage.setItem("", "search_text");

    this.setState({ isLoading: false });
  }

  componentDidUpdate() {
    setTimeout(() => {
      this.searchArray = [];
      let searchText = window.sessionStorage.getItem("search_text");
      window.sessionStorage.setItem("", "search_text");

      if (
        searchText !== null &&
        searchText !== undefined &&
        searchText !== ""
      ) {
        let corsiMatch = this.corsi.filter((corso) =>
          corso.name.toLowerCase().includes(searchText.toLowerCase())
        );
        let auleMatch = this.aule.filter((aula) =>
          aula.nome.toLowerCase().includes(searchText.toLowerCase())
        );
        let insegnantiMatch = this.insegnanti.filter(
          (insegnante) =>
            (
              insegnante.nome.toLowerCase() +
              " " +
              insegnante.cognome.toLowerCase()
            ).includes(searchText.toLowerCase()) ||
            (
              insegnante.cognome.toLowerCase() +
              " " +
              insegnante.nome.toLowerCase()
            ).includes(searchText.toLowerCase())
        );
        let studentiMatch = this.studenti.filter(
          (studente) =>
            (
              studente.nome.toLowerCase() +
              " " +
              studente.cognome.toLowerCase()
            ).includes(searchText.toLowerCase()) ||
            (
              studente.cognome.toLowerCase() +
              " " +
              studente.nome.toLowerCase()
            ).includes(searchText.toLowerCase())
        );

        corsiMatch.forEach((corso) => {
          let c = { id: corso.id, descrizione: corso.name, tipo: "Corso" };
          this.searchArray.push(c);
        });

        studentiMatch.forEach((studente) => {
          let s = {
            id: studente.id,
            descrizione: studente.nome + " " + studente.cognome,
            tipo: "Studente",
          };
          this.searchArray.push(s);
        });

        insegnantiMatch.forEach((insegnante) => {
          let i = {
            id: insegnante.id,
            descrizione: insegnante.nome + " " + insegnante.cognome,
            tipo: "Insegnante",
          };
          this.searchArray.push(i);
        });

        auleMatch.forEach((aula) => {
          let a = { id: aula.id, descrizione: aula.nome, tipo: "Aula" };
          this.searchArray.push(a);
        });
      }

      if (searchText !== this.state.previous)
        this.setState({ array: this.searchArray, previous: searchText });
    }, 200);
  }

  render() {
    if (this.state.isLoading) return <div />;
    var headCells = [
      {
        id: "descrizione",
        numeric: false,
        disablePadding: true,
        label: "Descrizione",
      },
      { id: "tipo", numeric: true, disablePadding: false, label: "Tipo" },
      { id: "_", numeric: true, disablePadding: false, label: "" },
    ];

    const cookies = new Cookies();
    this.searchCols = ["nome", "cognome", "mail"];

    return (
      <>
        <PageTitle title="Cerca" />

        <SearchTable
          headCells={headCells}
          searchCols={this.searchCols}
          assenze={true}
          calendar={false}
          pdf={true}
          excel={false}
          mail={true}
          phone={true}
          rows={this.state.array}
          onEventClick={(row, tipo) => {
            if (tipo === "Corso") {
              cookies.set("currentCourse", row, { path: "/" });
              window.location.href = "/#/app/editCorso";
            } else if (tipo === "Studente") {
              cookies.set("currentStudente", row, { path: "/" });
              window.location.href = "/#/app/editStudente";
            } else if (tipo === "Insegnante") {
              cookies.set("currentInsegnante", row, { path: "/" });
              window.location.href = "/#/app/editInsegnante";
            }
          }}
          onPdfClicked={(row, tipo) => {
            if (tipo === "Corso") {
              this.setState({
                selectPdfDatesVisible: true,
                pdfElem: row,
                pdfType: tipo,
              });
            } else if (tipo === "Studente") {
              cookies.set("requestedStudent", row, { path: "/" });
              window.location.href = "/#/app/pdfSingleStudent";
            } else if (tipo === "Insegnante") {
              this.setState({
                selectPdfDatesVisible: true,
                pdfElem: row,
                pdfType: tipo,
              });
            } else if (tipo === "Aula") {
              this.setState({
                selectPdfDatesVisible: true,
                pdfElem: row,
                pdfType: tipo,
              });
            }
          }}
          onSendMail={(id, tipo) => {
            this.sendMailRef.current && this.sendMailRef.current.reset();
            this.setState({
              sendMailVisible: true,
              sendMailUserId: id,
              mailType: tipo,
            });
          }}
          onSendNotification={(id, tipo) => {
            this.sendNotificationRef.current &&
              this.sendNotificationRef.current.reset();
            this.setState({
              sendNotificationVisible: true,
              notificationUser: id,
              notificationType: tipo,
            });
          }}
          onInvoicesPressed={(row, tipo) => {
            cookies.set("currentInsegnante", row, { path: "/" });
            window.location.href = "#/app/invoices";
          }}
          onAssenze={(row, tipo) => {
            cookies.set("currentStudent", row.id, { path: "/" });
            window.location.href = "/#/app/gestioneAssenze";
          }}
          onCalendarClick={(id, tipo) => {
            if (tipo === "Corso") {
              cookies.set("currentCourse", id, { path: "/" });
              window.location.href = "#/app/schedule";
            } else if (tipo === "Aula") {
              this.setState({
                selectedAula: id,
                selectDateAulaVisible: true,
                selectPdfDatesVisible: true,
              });
            }
          }}
        />

        <SelectPdfDatesWidget
          show={this.state.selectPdfDatesVisible}
          key={Math.random()}
          onCancel={() => console.log("Popup closed")}
          onOkClicked={(dateFrom, dateTo) => {
            if (this.state.pdfType === "Corso") {
              const cookies = new Cookies();
              cookies.set("currentCorso", this.state.pdfElem, { path: "/" });
              cookies.set("dateFrom", dateFrom, { path: "/" });
              cookies.set("dateTo", dateTo, { path: "/" });
              window.location.href = "#/app/pdfCorsoPage";
            } else if (this.state.pdfType === "Insegnante") {
              const cookies = new Cookies();
              cookies.set("currentInsegnante", this.state.pdfElem, {
                path: "/",
              });
              cookies.set("dateFrom", dateFrom, { path: "/" });
              cookies.set("dateTo", dateTo, { path: "/" });
              window.location.href = "#/app/pdfInsegnantiPage";
            } else {
              const cookies = new Cookies();
              cookies.set("currentAula", this.state.pdfElem, { path: "/" });
              cookies.set("dateFrom", dateFrom, { path: "/" });
              cookies.set("dateTo", dateTo, { path: "/" });
              window.location.href = "#/app/pdfAulaPage";
            }

            if (this.state.selectDateAulaVisible) {
              const cookies = new Cookies();
              cookies.set("currentAula", this.state.selectedAula, {
                path: "/",
              });
              cookies.set("dateFrom", dateFrom, { path: "/" });
              cookies.set("dateTo", dateTo, { path: "/" });
              window.location.href = "/#/app/detailAula";
            }
          }}
        />

        <SendMailWidget
          ref={this.sendMailRef}
          show={this.state.sendMailVisible}
          onClose={() => this.setState({ sendMailVisible: false })}
          onSend={async (subject, body, file) => {
            const cookies = new Cookies();
            const username = cookies.get("username", { path: "/" });
            const token = cookies.get("token", { path: "/" });
            this.mail = await getSetting(username, token, "sendingMailAddress");
            this.mailPassword = await getSetting(
              username,
              token,
              "sendingMailPassword"
            );

            if (this.state.mailType === "corso") {
              var corso = this.corsi.find(
                (s) => s.id == this.state.sendMailUserId
              );
              this.studentiCorso = this.studenti.filter((s) =>
                s.corsi
                  .split(";")
                  .filter(Boolean)
                  .includes(corso.id.toString())
              );

              if (file != undefined) {
                this.filePath = await saveFile(
                  username,
                  token,
                  file.name,
                  file.base64
                );
              }

              var incorrectMails = [];

              var indirizzi = "";
              var nomi = "";

              this.studentiCorso.forEach(async (studente) => {
                studente.mail = studente.mail.trim();
                studente.mail2 = studente.mail2.trim();

                if (studente.mail != "") {
                  if (Utils.validateEmail(studente.mail) == false)
                    incorrectMails.push(studente.mail);
                  else {
                    indirizzi += studente.mail + "---";
                    nomi += studente.nome + " " + studente.cognome + "---";
                  }
                }
                if (studente.mail2 != "") {
                  if (Utils.validateEmail(studente.mail2) == false)
                    incorrectMails.push(studente.mail2);
                  else {
                    indirizzi += studente.mail2 + "---";
                    nomi += studente.nome + " " + studente.cognome + "---";
                  }
                }
              });

              if (incorrectMails.length > 0) {
                var msg =
                  "I seguenti indirizzo mail non sono corretti e sarebbero ignorati:\n";
                incorrectMails.forEach((mail) => (msg += mail + "\n"));
                msg += "Inviare comunque la mail?";

                if (window.confirm(msg) == false) return;
              }

              indirizzi = indirizzi.substring(0, indirizzi.length - 3);
              nomi = indirizzi.substring(0, indirizzi.length - 3);
              await sendMail(
                username,
                token,
                this.mail,
                "Accademia Nazionale del Cinema",
                this.mailPassword,
                indirizzi,
                nomi,
                file ? this.filePath.name : "",
                subject,
                body
              );
            } else if (this.state.mailType === "Studente") {
              var studente = this.studenti.find(
                (s) => s.id == this.state.sendMailUserId
              );
              studente.mail = studente.mail.trim();
              studente.mail2 = studente.mail2.trim();

              if (file != undefined) {
                this.filePath = await saveFile(
                  username,
                  token,
                  file.name,
                  file.base64
                );
              }

              if (
                studente.mail != "" &&
                Utils.validateEmail(studente.mail) == false
              ) {
                alert("L'indirizzo " + studente.mail + " non è valido");
                return;
              }
              if (
                studente.mail2 != "" &&
                Utils.validateEmail(studente.mail2) == false
              ) {
                alert("L'indirizzo " + studente.mail2 + " non è valido");
                return;
              }

              if (studente.mail != "")
                await sendMail(
                  username,
                  token,
                  this.mail,
                  "Accademia Nazionale del Cinema",
                  this.mailPassword,
                  studente.mail,
                  studente.nome + " " + studente.cognome,
                  file ? this.filePath.name : "",
                  subject,
                  body
                );
              if (studente.mail2 != "")
                await sendMail(
                  username,
                  token,
                  this.mail,
                  "Accademia Nazionale del Cinema",
                  this.mailPassword,
                  studente.mail2,
                  studente.nome + " " + studente.cognome,
                  file ? this.filePath.name : "",
                  subject,
                  body
                );
            } else if (this.state.mailType === "Insegnante") {
              var insegnantiMail = this.insegnanti.filter(
                (s) => this.state.sendMailUserId.indexOf(s.id) != -1
              );

              if (file != undefined) {
                this.filePath = await saveFile(
                  username,
                  token,
                  file.name,
                  file.base64
                );
              }

              insegnantiMail.forEach(async (insegnante) => {
                insegnante.mail = insegnante.mail.trim();
                insegnante.mail2 = insegnante.mail2.trim();

                if (
                  insegnante.mail != "" &&
                  Utils.validateEmail(insegnante.mail) == false
                ) {
                  alert("L'indirizzo " + insegnante.mail + " non è valido");
                  return;
                }
                if (
                  insegnante.mail2 != "" &&
                  Utils.validateEmail(insegnante.mail2) == false
                ) {
                  alert("L'indirizzo " + insegnante.mail2 + " non è valido");
                  return;
                }

                if (insegnante.mail != "")
                  await sendMail(
                    username,
                    token,
                    this.mail,
                    "Accademia Nazionale del Cinema",
                    this.mailPassword,
                    insegnante.mail,
                    insegnante.nome + " " + insegnante.cognome,
                    file ? this.filePath.name : "",
                    subject,
                    body
                  );
                if (insegnante.mail2 != "")
                  await sendMail(
                    username,
                    token,
                    this.mail,
                    "Accademia Nazionale del Cinema",
                    this.mailPassword,
                    insegnante.mail2,
                    insegnante.nome + " " + insegnante.cognome,
                    file ? this.filePath.name : "",
                    subject,
                    body
                  );
              });
            }

            this.setState({ waitDialogVisible: false });
            this.setState({ sendMailVisible: false });
          }}
        />

        <SendNotificationWidget
          ref={this.sendNotificationRef}
          show={this.state.sendNotificationVisible}
          onClose={() => this.setState({ sendNotificationVisible: false })}
          onSend={async (subject, body, bodyFull) => {
            const cookies = new Cookies();
            const username = cookies.get("username", { path: "/" });
            const token = cookies.get("token", { path: "/" });

            if (this.state.notificationType === "Insegnante") {
              await addNotification(
                username,
                token,
                "INSEGNANTE",
                this.state.notificationUser,
                subject,
                body,
                bodyFull,
                0
              );
            } else if (this.state.notificationType === "Studente") {
              await addNotification(
                username,
                token,
                "STUDENTE",
                this.state.notificationUser,
                subject,
                body,
                bodyFull,
                0
              );
            } else if (this.state.notificationType === "Corso") {
              var studentiCorso = await getStudenti(username, token);
              studentiCorso = studentiCorso.filter((s) =>
                s.corsi
                  .split(";")
                  .filter(Boolean)
                  .includes(this.state.notificationUser.toString())
              );

              await addNotification(
                username,
                token,
                "CORSO",
                this.state.notificationUser,
                subject,
                body,
                bodyFull,
                0
              );

              studentiCorso.forEach(async (studente) => {
                await addNotification(
                  username,
                  token,
                  "STUDENTE",
                  studente.id,
                  subject,
                  body,
                  bodyFull,
                  1
                );
              });
            }

            this.setState({ waitDialogVisible: false });
            this.setState({ sendNotificationVisible: false });
          }}
        />
      </>
    );
  }
}
